<script lang="ts" setup>
interface Props {
  images: Record<string, string> // size, src
  sizes: Record<string, number> // size, maxWidth (breakpoint)
  defaultSize: string
  loading?: 'lazy' | 'eager'
}

defineProps<Props>()

defineEmits(['load'])
</script>

<template>
  <picture>
    <source
      v-for="(maxWidth, size) in sizes"
      :key="size"
      :media="`(max-width: ${maxWidth}px)`"
      :srcset="images[size]"
    >
    <source :srcset="images[defaultSize]">
    <img
      :loading="loading ?? 'eager'"
      :src="images[defaultSize]"
      v-bind="$attrs"
      @load="$emit('load')"
      @error="$emit('load')"
    >
  </picture>
</template>
